






























































import Vue from 'vue';
import { Location } from 'vue-router';
import { PageInternalNav } from '@/components/page-components';
import { SubstantiationAlert } from '@/components/account-components';
import store from '@/store';
import { LoadingService } from '@/services';
import { EventBus } from '@/event-bus';
import { getContentArea } from '@/contentful';
import {
  CTA,
  MemberAccountResponseModel,
  UserModel,
} from '@/@types/member';

interface Data {
  eligibleExpensesLink: Location;
}

export default Vue.extend({
  name: 'Account',
  beforeRouteEnter(to, from, next) {
    const promises = [
      store.dispatch('getAccounts'),
      getContentArea(['account-eligible-expenses-link']),
    ];
    LoadingService.watchPromises(promises)
      .then((data) => {
        const contentAreas = data[1];
        if (contentAreas) {
          if (contentAreas[0] && contentAreas[0].fields) {
            let regex;
            const link = contentAreas[0].fields.actionValue;
            if (link.indexOf('route="') > -1) {
              regex = /(route=")(.*)(")/g;
            } else if (link.indexOf('link="') > -1) {
              regex = /(link=")(.*)(")/g;
            } else if (link.indexOf('link:self="') > -1) {
              regex = /(link:self=")(.*)(")/g;
            }
            to.meta.eligibleExpensesLink = link.replace(
              regex,
              (match, a, b) => {
                return b;
              },
            );
          }
        }
        next();
      })
      .catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          action: {
            label: 'global_try-again',
            performAction() {
              location.reload();
            },
          },
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  data(): Data {
    return {
      eligibleExpensesLink: this.$route.meta.eligibleExpensesLink,
    };
  },
  computed: {
    user(): UserModel {
      return this.$store.getters.user;
    },
    navItems(): CTA[] {
      const navItems: CTA[] = [
        {
          to: { name: 'overview' },
          text: ['account_menu-item_overview', 'global_overview'],
          icon: 'show_chart',
        },
        {
          to: { name: 'activity' },
          text: ['account_menu-item_activity', 'global_activity'],
          icon: 'credit_card',
        },
        {
          to: { name: 'statements' },
          text: ['account_menu-item_statements', 'global_statements'],
          icon: 'insert_drive_file',
        },
      ];

      if (this.account.productType === 'HSA') {
        navItems.push({
          to: { name: 'taxForms' },
          text: ['account_menu-item_tax-forms', 'global_tax-forms'],
          icon: 'attach_money',
        });
      }

      // MBR-011: BR-1.06 & BR-1.07
      if (
        (this.account.productType === 'HSA' ||
        this.account.productType === 'VEBA')
        && this.account.allowBeneficiaryChange
      ) {
        navItems.push({
          to: { name: 'beneficiaries' },
          text: [
            'account_menu-item_beneficiaries',
            'global_beneficiaries',
          ],
          icon: 'person',
        });
      }

      if (
        (this.account.productType === 'HSA' ||
        this.account.productType === 'VEBA' ||
        this.account.productType === 'FSA')
      ) {
      navItems.push({
        to: this.eligibleExpensesLink,
        external: true,
        text: ['account_menu-item_eligibility', 'global_eligibility'],
        icon: 'check_circle',
      });
      }
      return navItems;
    },
    account(): MemberAccountResponseModel {
      return this.$store.getters.currentAccount(this.$route.params.id);
    },
  },
  components: {
    PageInternalNav,
    SubstantiationAlert,
  },
});
